"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScrollBufferOffset = exports.getScrollBufferOpacity = void 0;
var makeScrollContainerStyling_1 = require("./makeScrollContainerStyling");
/**
 * When scrolling near the bottom of the window. The buffer will fade from view.
 * This is calculated as a ratio of the distance scrolled through the padding.
 */
var getScrollBufferOpacity = function (scrollDetails) {
    if (scrollDetails !== null) {
        var remainingScroll = scrollDetails.scrollHeight -
            scrollDetails.clientHeight -
            scrollDetails.scrollTop;
        if (remainingScroll < makeScrollContainerStyling_1.SCROLL_PADDING_HEIGHT) {
            return remainingScroll / makeScrollContainerStyling_1.SCROLL_PADDING_HEIGHT;
        }
    }
    return 1;
};
exports.getScrollBufferOpacity = getScrollBufferOpacity;
/**
 * Calculates the distance from the top of the page to the intended top of the scroll buffer.
 */
var getScrollBufferOffset = function (scrollDetails) {
    return scrollDetails !== null
        ? scrollDetails.offsetTop +
            scrollDetails.clientHeight -
            makeScrollContainerStyling_1.SCROLL_BUFFER_HEIGHT
        : 0;
};
exports.getScrollBufferOffset = getScrollBufferOffset;
//# sourceMappingURL=ScrollContainerHelpers.js.map